<template>
  <Navbar />
  <SubNav></SubNav>
  <!-- <secondNav></secondNav> -->
  <main class="school-main">
    <div class="w-100">
      <slot></slot>
    </div>
  </main>
</template>

<script setup lang="ts">
import Navbar from "@/components/support/layout/Navbar.vue";
import SubNav from "@/components/support/layout/Subnav.vue";

//
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;
// .school-main {
//   // flex: 1 1 auto !important;
//   // overflow: auto;
// }
</style>
